var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5135_83026)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(-753 -782)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5135_83026)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5135_83026)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 438,
    height: 48,
    transform: "translate(-12 -12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_5135_83026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4.5H19V13.5L12 18L5 13.5V4.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -11.5,
    y: -59.5,
    width: 437,
    height: 95,
    rx: 5.5,
    stroke: "#070A26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5135_83026",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5135_83026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(-753 -782)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5135_83026"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -242,
    y: -648,
    width: 898,
    height: 680,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5135_83026"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -60,
    width: 438,
    height: 96,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_5135_83026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5135_83026",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAqVJREFUWEfNVu1x2kAQfauP36GDkApCKgiU4ApsfoNIVIGTCsBI/m1cgekAXIGVCkw6oABJl1mdZPRxJ+kYZsjNeMYz6Hbfvn379ghXPnTl/PiPAQTBPYDxxRiyLB+zWVSPp2YgCH4AWF0suQwUwfO+dQNYLodw3R2EGF4YACCEj8WiUliTgTB8ghB3F08uAx4Rx1/g+8cifhXAen0HoqdGciGmIDqcAWrXuEO0wnzuNwEslwO47puSeqIh5vO/xgCCQGjuTOB5e/7txMB6vQTRT82FG8TxB235Nwf4vmSFwQOjxl3HaTIgP9rD8yYnACw8x3k3qpDbslhscgBj6JOpw+aClAyE4Xsv1QtxAFEEoiOEeC5ohJyc+zyGmo0mjEyQBGk4v1qq5179RhxHZfVmtBdqLv9fBAoCNjGeplttbKIVIQxZeM3+lceGHdF1v0MIDsr+MIC6BawTyVKaviJJtrmnqOMTHQi60csUQgckyTMsi1mqH2YlUzIc56vSOYk2eVvUlk7kSw3oQUjj4IptewwiroSTMQPc6+phwPyXpn9g2/vM+4PgTTkhljXFbLY5jaHs2UsWvHxkwAckCS+Sqg5UzZUjOcwAW9atsr158tMYFoEeH0dIU57dZnWnZNxnBvMAz9vmYziC47CFD8CmpTtCHEE0/bhXMSIzELxYzHyAkyfJBL5fWcnqdcxzbdu7jmr6A9Akb7agTF0XiL4MsHklyU298iJV+5OsHcQ2Uzsf2/6sXOEyOdOu3aTdb8IuJvSC60ze3gKTdtRB9Ki8XwvOAWGQvD8DBRC5ttms1N5umNwcAN9gp5O7vw4iQhyz2o2ebt0i1NltFQQnZ7XXX01aUzTXQD2UZIKf2J8Qx9Nzkp/Xgs6azD44rwVmOVq/vjqAfzYsPLSjupmHAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.fedc8e011cf426d2cc37bca45d4d4903.svg";
export { ForwardRef as ReactComponent };